var $8b8ad8904d69cbb9$exports = {};
// Current-page state for the shared nav partial (see src/_includes/_nav.html).
// The partial is static (posthtml-include has no parameters), so the
// current section is derived from the URL: deepest matching section wins,
// which keeps case studies under Work and app pages under Apps.
const $8b8ad8904d69cbb9$var$links = document.querySelectorAll(".site-nav-link");
if ($8b8ad8904d69cbb9$var$links.length > 0) {
    const path = window.location.pathname;
    let current = "/";
    $8b8ad8904d69cbb9$var$links.forEach((link)=>{
        const href = link.getAttribute("href");
        if (href !== "/" && path.startsWith(href) && href.length > current.length) current = href;
    });
    $8b8ad8904d69cbb9$var$links.forEach((link)=>{
        if (link.getAttribute("href") === current) link.setAttribute("aria-current", "page");
    });
}


//# sourceMappingURL=404.fe9589e4.js.map
